import { Map } from "immutable";
import { keys, uniq } from "lodash";
import createCachedSelector from "re-reselect";

import { dateConstraintSelectors } from "../../../../dateConstraints";
import { calendarSelectors } from "../../../../definition/calendar";
import dateByAddingSpan from "../../../../definition/calendar/dateFunctions/dateByAddingSpan";
import { typeSelectors } from "../../../../definition/types";
import { dependencySelectors } from "../../../../dependencies";
import { isConstraintViolated } from "../../../../display/validatedDateConstraints/selectors";
import { isDependencyViolated } from "../../../../display/validatedDependencies/selectors";
import itemSelectors from "../../../selectors";

const removeItemIdsOfNonDateTypes = (ids, itemsById, typesById) => {
  let result = [];
  if (ids) {
    result = ids.filter(id => {
      const item = itemsById.get(id);
      if (item) {
        const type = typesById.get(item.type);
        return type ? typeSelectors.isDatedType(type) : false;
      }
      return false;
    });
  }
  return result;
};

const getFakeItem = createCachedSelector(
  // input
  (item, _calendar) => item,
  (item, calendar) => calendar,
  // output
  (item, calendar) => {
    return {
      startDate: item.startDate,
      endDate: item.startDate && item.duration ? dateByAddingSpan(calendar, item.startDate, item.duration) : null
    };
  }
)(item => item.id);

const calculateViolatedItems = state => {
  const calendar = calendarSelectors.getCalendar(state);
  const itemsById = itemSelectors.getItemsById(state);
  const dependencies = dependencySelectors.getDependenciesById(state);
  const constraints = dateConstraintSelectors.getDateConstraintsById(state);

  const violatedDepItemIds = dependencies.reduce((result, dep) => {
    const fakeItems = {
      [dep.subject]: getFakeItem(itemsById.get(dep.subject), calendar),
      [dep.object]: getFakeItem(itemsById.get(dep.object), calendar)
    };
    if (isDependencyViolated(dep, Map(fakeItems))) {
      result.push(...keys(fakeItems));
    }
    return result;
  }, []);

  const violatedConstraintItemIds = constraints.reduce((result, constraint) => {
    let fakeItems = {
      [constraint.subject]: getFakeItem(itemsById.get(constraint.subject), calendar)
    };
    if (constraint.object) {
      fakeItems[constraint.object] = getFakeItem(itemsById.get(constraint.object), calendar);
    }
    if (isConstraintViolated(constraint, calendar, Map(fakeItems))) {
      result.push(...keys(fakeItems));
    }
    return result;
  }, []);

  return uniq([...violatedDepItemIds, ...violatedConstraintItemIds]);
};

export { calculateViolatedItems, removeItemIdsOfNonDateTypes };
